import UilAngleDown from '@iconscout/react-unicons/icons/uil-angle-down';
import UilSignout from '@iconscout/react-unicons/icons/uil-signout';
import UilUser from '@iconscout/react-unicons/icons/uil-user';
import { Avatar } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { InfoWraper, UserDropDwon } from './auth-info-style';
import OrganizationSelector from './OrganizationSelector';
import ModeSelector from './ModeSelector';
import { logOut } from '../../../redux/authentication/actionCreator';

import Heading from '../../heading/heading';
import { Popover } from '../../popup/popup';

const AuthInfo = React.memo(() => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = JSON.parse(Cookies.get('user'));
  const navigate = useNavigate();

  const SignOut = (e) => {
    e.preventDefault();

    dispatch(logOut(() => navigate('/')));
  };

  const userContent = (
    <UserDropDwon>
      <div className="user-dropdwon">
        <figure className="user-dropdwon__info">
          <img src={user?.avatar || require('../../../static/img/user.png')} alt="" width={50} height={50} />
          <figcaption>
            <Heading as="h5">{`${user.name} ${user.lastname}`}</Heading>
          </figcaption>
        </figure>
        <ul className="user-dropdwon__links">
          <li>
            <Link to="/profile">
              <UilUser /> {t('profile')}
            </Link>
          </li>
        </ul>
        <Link className="user-dropdwon__bottomAction" onClick={SignOut} to="#">
          <UilSignout /> {t('sign-out')}
        </Link>
      </div>
    </UserDropDwon>
  );

  return (
    <InfoWraper className="ninjadash-auth-info-wrap">
      <ModeSelector />
      <OrganizationSelector />
      <div className="ninjadash-nav-actions__item ninjadash-nav-actions__author">
        <Popover placement="bottomRight" content={userContent} action="click">
          <Link to="#" className="ninjadash-nav-action-link">
            <Avatar src={`${user?.avatar || require('../../../static/img/user.png')}`} />
            <span className="ninjadash-nav-actions__author--name">{`${user?.name} ${user?.lastname}`}</span>
            <UilAngleDown />
          </Link>
        </Popover>
      </div>
    </InfoWraper>
  );
});

export default AuthInfo;
